import { observer } from 'mobx-react-lite';
import { Button, Header } from 'semantic-ui-react';
import { useStore } from './../../stores/store';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import { setTimeout } from 'timers';
import { useNavigate } from 'react-router-dom';
import agent from '../../api/agent';
interface Props {
  type: string;
  name: string;
  data: any;
  updateHandler?: () => void;
}
function DeleteConfirmation({ type, name, data, updateHandler }: Props) {
  const {
    userStore,
    receivingdeliveryStore,
    modalStore,
    activityStore,
    vaultStore,
    ShelfRackStore,
    DeviceStore,
    mediaAssetStore,
    clonedStore,
    departmentStore,
    customerStore,
    WorkLevelStore,
    reportStore,
    dashboardStore,
    commonStore,
    viewStore: { confirmItemDelete, deleteCircuit },
  } = useStore();

  const history = useNavigate();

  const handleDelete = async (type: string, data: any) => {
    const newArr = { ...data, isDeleted: true };
    if (type === 'ReceivingTable') {
      dashboardStore.updateCountOrderMenu(userStore.user?.id);
      receivingdeliveryStore.deleteReceivingDelivery(newArr);
    } else if (type === 'VaultTable') {
      // !shelfLength&&!deviceLength&&vaultStore.deleteVault(newArr);
      vaultStore.deleteVault(newArr);
    } else if (type === 'ShelfRackTable') {
      ShelfRackStore.deleteShelfRack(newArr);
    } else if (type === 'DeviceTable') {
      DeviceStore.deleteDevice(newArr);
    } else if (type === 'DepartmentTable') {
      departmentStore.deleteDepartment(newArr);
    } else if (type === 'CustomerTable') {
      customerStore.deleteCustomer(newArr);
    } else if (type === 'WorkLevelTable') {
      WorkLevelStore.deleteWorkLevel(newArr);
    } else if (type === 'Parent') {
      const p1 = new Promise((resolve) => {
        reportStore.SectionRemoveLink(
          data.id,
          type,
          activityStore.selectedActivity?.id +
            '/' +
            activityStore.selectedActivity?.title,
        );
        clonedStore.existingData = clonedStore.existingData.filter(
          (x) => x !== data.id,
        );
        mediaAssetStore.mediaAsset.refreshSectionMain =
          !mediaAssetStore.mediaAsset.refreshSectionMain;
        resolve('');
      });
      p1.then(() => {
        setTimeout(() => {
          clonedStore.loadSectionById(
            activityStore.selectedActivity?.id +
              '/' +
              activityStore.selectedActivity?.title,
          );
        }, 500);
      });
    } else if (type === 'Existing') {
      const p1 = new Promise((resolve) => {
        reportStore.SectionRemoveLink(
          data.id,
          type,
          activityStore.selectedActivity?.id,
        );
        clonedStore.existingData = clonedStore.existingData.filter(
          (x) => x !== data.id,
        );
        mediaAssetStore.mediaAsset.refreshSectionMain =
          !mediaAssetStore.mediaAsset.refreshSectionMain;
        resolve('');
      });
      p1.then(() => {
        setTimeout(() => {
          clonedStore.loadSectionById(
            activityStore.selectedActivity?.id +
              '/' +
              activityStore.selectedActivity?.title,
          );
        }, 500);
      });
    } else if (type === 'MasterTable') {
      const params = { itemId: data.id };
      await confirmItemDelete(params, WorkLevelStore.masterReportsId);
    } else if (type === 'HFCShipperMovement') {
      await agent.HFC.HFCDeliveryRequestDelete(data.id)
      activityStore.HFCDeliveryRequest(1, userStore?.user!.id, 5, []) 
      deleteCircuit({ itemId: data?.asset_ID});
    } else {
      const params = { itemId: data.id };
      await confirmItemDelete(
        params,
        undefined,
        type === 'dashboard' ? updateHandler?.() : history('/mediaAssets'),
      );
    }
    modalStore.closeModal();
  };

  const title: string =
    type === 'ReceivingTable'
      ? data.receivingTitle
      : type === 'VaultTable'
        ? data.vaultName
        : type === 'ShelfRackTable'
          ? `Shelf ${data.shelfNumber}`
          : type === 'DeviceTable'
            ? data.device_Type
            : type === 'DepartmentTable'
              ? data.department_Name
              : type === 'CustomerTable'
                ? data.customer_Name
                : type === 'WorkLevelTable'
                  ? data.title
                  : type === 'Parent'
                    ? name
                    : data?.title;

  const handleClose = () => {
    modalStore.closeModal();
  };
  return (
    <>
      <>
        <Header
          as="h1"
          color="red"
          content={type === 'Parent' ? 'Remove Link' : 'Delete Confirmation'}
          icon="delete"
          size="large"
        />
        <div>
          <hr
            style={{
              color: 'black',
              backgroundColor: 'black',
              height: 2,
            }}
          />

          <Header
            as="h3"
            content={
              type === 'Parent'
                ? `Are you sure, you want to Remove Link - ${title} `
                : `Are you sure, you want to delete - ${title}`
            }
          />
          <Header />
          <Header />
        </div>
        <Button.Group
          floated="left"
          attached="bottom"
          style={{ marginBottom: '10px' }}
        >
          <Button
            onClick={handleClose}
            //No
          >
            {
              (
                userLanguage[0]
                  .Level3InventoryRecievingVerifyTableDeleteConfirmationModal
                  ?.IRVTDCMB01 as any
              )?.[`${commonStore.language.key}`]
            }
          </Button>
          <Button.Or
            text={
              (
                userLanguage[0]
                  .Level3InventoryRecievingVerifyTableDeleteConfirmationModal
                  ?.IRVTDCMB02 as any
              )?.[`${commonStore.language.key}`]
            }
          />
          <Button
            positive
            onClick={() => handleDelete(type, data)}
            labelPosition="right"
            icon="checkmark"
            //content="Yes"
            content={
              (
                userLanguage[0]
                  .Level3InventoryRecievingVerifyTableDeleteConfirmationModal
                  ?.IRVTDCMB03 as any
              )?.[`${commonStore.language.key}`]
            }
          />
        </Button.Group>
      </>
      {/* } */}
    </>
  );
}

export default observer(DeleteConfirmation);
